<template>
  <div class="jumbotron">
        <h2>Work</h2>
      <div class="container">
      </div>
  </div>
        <!-- healrefreshHP -->
        <div class="col-md-4">
          <div class="card mb-4 shadow-sm">
            <img class="card-img-top" src="../assets/healHP.png" alt="Card image cap">
            <h5>大井町気導術サロンHP</h5>
            <div class="card-body">
              <ul class="card-text">
                <li>WordPress(Cocoon)で0からHP作成</li>
                <li>GoogleMap埋め込み</li>
                <li>問い合わせフォーム作成</li>
              </ul>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <p><a class="btn btn-secondary" href="http://healrefresh.wp.xdomain.jp/" role="button">GO TO HP &raquo;</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- misatoHP -->
        <div class="col-md-4">
          <div class="card mb-4 shadow-sm">
            <img class="card-img-top" src="../assets/misatoHP.png" alt="Card image cap">
            <h5>かとうみさとのHP</h5>
            <div class="card-body">
              <ul class="card-text">
                <li>HP更新作業</li>
                <li>HTML,CSS,JavaScript,JQuery</li>
                <li>画像、文章、YouTube埋め込み</li>
              </ul>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <p><a class="btn btn-secondary" href="http://misatokato.com/" role="button">GO TO HP &raquo;</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FGO Youtuve -->
        <div class="col-md-4">
          <div class="card mb-4 shadow-sm">
            <img class="card-img-top" src="../assets/fgo.png" alt="Card image cap">
            <h5>動画編集</h5>
            <div class="card-body">
              <ul class="card-text">
                <li>Adobe Premiere使用</li>
                <li>友人のイラストレーターと趣味で制作</li>
                <li>画像、効果音、音声MIX</li>
                <li>テロップ、炎の動画背景合成etc..</li>
              </ul>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <p><a class="btn btn-secondary" href="https://www.youtube.com/watch?v=sswjBaXnF9Q&t=3s" role="button">GO TO YouTube &raquo;</a></p>
                </div>
              </div>
            </div>
            </div>
          </div>
  <!-- MasakiHP -->
  <div class="album py-5 bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-4">
          <div class="card mb-4 shadow-sm">
            <img class="card-img-top" src="../assets/masakiHP.png" alt="Card image cap">
            <h5>Masaki's HP</h5>
            <div class="card-body">
              <ul class="card-text">
                <li>Vue.js 3, Node.js, BootStrap5</li>
                <li>SPAで画面高速切替、多様なUI</li>
                <li>2020年9月リリースのVue3を試しかった</li>
              </ul>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <p><a class="btn btn-secondary" role="button">Here HP &raquo;</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
          <!-- Gameとか -->
        <div class="col-md-4">
          <div class="card mb-4 shadow-sm">
            <img class="card-img-top" src="../assets/java.png" alt="Card image cap">
            <h5>Comming Soon</h5>
            <div class="card-body">
              <ul class="card-text">
                <li></li>
              </ul>
              <div class="d-flex justify-content-between align-items-center">
                <div class="btn-group">
                  <!-- <p><a class="btn btn-secondary" href="" role="button">GO TO YouTube &raquo;</a></p> -->
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style scoped>
ul {
  list-style: none;
}

h2 {
  position: relative;
  padding: 1rem 2rem calc(1rem + 10px);
  background: #fff100;
}

h2:before {
  position: absolute;
  top: -7px;
  left: -7px;
  width: 100%;
  height: 100%;
  content: '';
  border: 4px solid #000;
}
</style>
